import { Vec3 } from 'vec3';
export declare const server: (serv: Server, settings: Options) => void;
export declare const player: (player: Player, serv: Server) => void;
declare global {
    interface Server {
    }
    interface Player {
        /** Either serv.spawnPoint or randomly selected for each player. Possibly could be overridden in future (e.g. beds or anchors), serv global serv.spawnPoint should as fallback */
        spawnPoint: Vec3;
        /** The view size of the player, for example 8 for 16x16 */
        view: number;
    }
}
